import log from 'loglevel';
import {
  FETCH_WORKFLOW,
  FETCH_PRODUCTS,
  UPDATE_CURRENT_GUID,
  UPDATE_SEEN_GUIDS,
  UPDATE_CURRENT_PROMPT,
  UPDATE_DEFAULT_SUPPORT_SKILL,
  UPDATE_SFDC_TYPE,
  UPDATE_SFDC_TOPIC,
  UPDATE_PREMIUM_SUPPORT_SKILL,
  UPDATE_PREMIUM_SFDC_TYPE,
  UPDATE_PREMIUM_SFDC_TOPIC,
  UPDATE_SHOW_CONTACT_FOOTER,
  UPDATE_DEFAULT_ESCAPE_ACTION_GUID,
  UPDATE_SHOW_CONTACT_DETAILS_IN_ACTION,
  UPDATE_HIDE_TOPIC_NOT_LISTED,
  UPDATE_CURRENT_TOP_LEVEL_BRANCH,
  UPDATE_HIDE_CONTACT,
  UPDATE_SHOW_RESELLER_CONTACT,
  UPDATE_USER_CONTEXT,
  UPDATE_LINK_TO_ADN_SUPPORT_PAGE,
  RESET_DISAMBIGUATION_STATES,
} from './types';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import {isObjectEmpty} from '../utils/utilFunctions';
import {getCleanedProductReleases} from '../utils/utilProductsReleases';
import {updateProductDetails} from '../actions/settingActions';
import {store} from '../configureStore';
import {dtReportCustomError} from '@adsk/ha-dynatrace-util';

// Get the workflow dynamically
import {siteTierConfig} from '../app.config';
// to test local workflow
// import deWorkflow from '../test_data/dotComJson_de_DE.json';
import worker from 'workerize-loader!../workers/worker'; // eslint-disable-line import/no-webpack-loader-syntax
let workerInstance = worker()  // `new` is optional

export const fetchWorkflow = (
  workflowJson,
  gotData,
  fallbackWorkflowJson
) => async (dispatch) => {
  let data;

  if (isObjectEmpty(gotData)) {
    try {
      data = await workerInstance.getApiData({url: workflowJson, options: {
        timeout: 10000,
      }})
      // data = deWorkflow; // to test local workflow
    } catch (error) {
      if (fallbackWorkflowJson) {
        try {
          data = await workerInstance.getApiData({url: fallbackWorkflowJson, options: {
            timeout: 10000,
          }});
        } catch (err) {
          log.error(
            'Unable load UHM workflow json',
            Object.keys(err),
            error.message
          );
        }
      } else {
        log.error(
          'Unable load UHM workflow json',
          Object.keys(error),
          error.message
        );
      }
    }
  } else {
    data = gotData;
  }

  dispatch({
    type: FETCH_WORKFLOW,
    payload: data,
  });
};

export const fetchProductReleases = (gotData) => async (dispatch) => {
  let data;
  if (isObjectEmpty(gotData)) {
    let responseData;
    try {
      const response = await workerInstance.getApiData({url: siteTierConfig.productsApi, options: {
        timeout: 10000,
      }});
      responseData = response?.products;
      // data = jsonData;
    } catch (error) {
      log.error(Object.keys(error), error.message);
      dtReportCustomError({
        error,
        errorCode: 'KP_PROD_LIST_ERR',
        errorText: 'Error retrieving product list(legacy)',
      });
    }
    data = getCleanedProductReleases(responseData);
  } else {
    data = gotData;
  }

  const getStore = store.getState();

  // Get the PLC code from store to update product details.
  const {value: plc} = getStore.appSettings.productDetails;
  if (!isEmpty(plc)) {
    // find the product object in productReleases
    let findProd = find(data, ['value', plc]);

    if (typeof findProd !== 'undefined' && !isEmpty(findProd)) {
      // update the value of selectedProduct with Name and Releases.
      dispatch(updateProductDetails(findProd));
    }
  }

  dispatch({
    type: FETCH_PRODUCTS,
    payload: data,
  });
};

export const updateCurrentGuid = (guid) => {
  return {
    type: UPDATE_CURRENT_GUID,
    payload: guid,
  };
};

export const updateSeenGuids = (seenGuids, goToGuid) => {
  const index = seenGuids.indexOf(goToGuid);
  let newState = [];
  if (index >= 0) {
    newState = seenGuids.slice(0, index + 1);
  } else {
    newState = [...seenGuids, goToGuid];
  }

  return {
    type: UPDATE_SEEN_GUIDS,
    payload: newState,
  };
};

export const updateCurrentPrompt = (data) => {
  return {
    type: UPDATE_CURRENT_PROMPT,
    payload: data,
  };
};

export const updateDefaultSupportSkill = (data) => {
  return {
    type: UPDATE_DEFAULT_SUPPORT_SKILL,
    payload: data,
  };
};

export const updateSfdcType = (data) => {
  return {
    type: UPDATE_SFDC_TYPE,
    payload: data,
  };
};

export const updateSfdcTopic = (data) => {
  return {
    type: UPDATE_SFDC_TOPIC,
    payload: data,
  };
};
export const updatePremiumSupportSkill = (data) => {
  return {
    type: UPDATE_PREMIUM_SUPPORT_SKILL,
    payload: data,
  };
};

export const updatePremiumSfdcType = (data) => {
  return {
    type: UPDATE_PREMIUM_SFDC_TYPE,
    payload: data,
  };
};

export const updatePremiumSfdcTopic = (data) => {
  return {
    type: UPDATE_PREMIUM_SFDC_TOPIC,
    payload: data,
  };
};

export const updateShowContactFooter = (data) => {
  return {
    type: UPDATE_SHOW_CONTACT_FOOTER,
    payload: data,
  };
};

export const updateDefaultEscapeActionGuid = (data) => {
  return {
    type: UPDATE_DEFAULT_ESCAPE_ACTION_GUID,
    payload: data,
  };
};

export const updateShowContactDetailsInAction = (data) => {
  return {
    type: UPDATE_SHOW_CONTACT_DETAILS_IN_ACTION,
    payload: data,
  };
};

export const updateHideTopicNotListed = (data) => {
  return {
    type: UPDATE_HIDE_TOPIC_NOT_LISTED,
    payload: data,
  };
};

export const updateHideContactModalities = (data) => {
  return {
    type: UPDATE_HIDE_CONTACT,
    payload: data,
  };
};

export const updateShowResellerContactModality = (data) => {
  return {
    type: UPDATE_SHOW_RESELLER_CONTACT,
    payload: data,
  };
};

export const updateCurrentTopLevelBranch = (data) => {
  return {
    type: UPDATE_CURRENT_TOP_LEVEL_BRANCH,
    payload: data,
  };
};

export const updateUserContext = (data) => {
  return {type: UPDATE_USER_CONTEXT, payload: data};
};

export const updatelinkToADNSupportPage = (data) => {
  const result = {type: UPDATE_LINK_TO_ADN_SUPPORT_PAGE, payload: data};
  return result;
};
export const resetDisambiguationStates = (data) => {
  const result = {type: RESET_DISAMBIGUATION_STATES, payload: data};
  return result;
};
